import { tenantRoute } from "../utils/tenantRoute";

/** A signed-out page whose path is a bearer token: the outside-party guest page and a product
 *  update email's stop page. Any case, as React Router matches `/EMAIL/STOP/<token>` too. */
const TOKEN_PAGE = /^\/(?:guest|email\/stop)\//i;

/** Whether `pathname` is a token page: no analytics, no sign-in bounce (its token would be kept
 *  as the return path). */
export const isTokenPage = (pathname: string): boolean => TOKEN_PAGE.test(pathname);

/** Guest links and a product update email's stop link carry a bearer token in the path
 *  (`/guest/<token>`, `/email/stop/<token>`, any case); it must never reach analytics or a
 *  diagnostic report. Works on a path, a URL or free text (an error message, a stack):
 *  everything after the prefix up to the next `/` or `?` is replaced. */
export function redactGuestTokens(text: string): string {
    return text.replace(/(\/guest\/|\/email\/stop\/)[^/?]+/gi, "$1[redacted]");
}

/**
 * The path analytics names a page by: the app's route (`tenantRoute`), so a URL tab's
 * `/{company}/{project}` prefix is dropped and a page has one path on every tab, and
 * the tenant travels as `org_slug` instead. Guest links carry a bearer token in the
 * path; it must never reach analytics.
 */
export function routePath(pathname: string): string {
    return redactGuestTokens(tenantRoute(pathname).pathname);
}
